import GlobalStyle from './global';
import colors from './colors';
import * as defaults from './defaults';

export default GlobalStyle;

export { colors, defaults };
